'use client';

import type { Country, State, Currency } from '@impact/types';
import { trpc } from '@/lib/trpc';

type CountryQueryResult = ReturnType<typeof trpc.lookups.countries.useQuery> & {
  data: Country[] | undefined;
};
type StateQueryResult = ReturnType<typeof trpc.lookups.states.useQuery> & {
  data: State[] | undefined;
};
type CurrencyQueryResult = ReturnType<typeof trpc.lookups.currencies.useQuery> & {
  data: Currency[] | undefined;
};

/**
 * Query hook for fetching countries
 */
export function useCountries() {
  return trpc.lookups.countries.useQuery({}) as CountryQueryResult;
}

/**
 * Query hook for fetching states/regions for a country
 */
export function useStates(countryId?: string) {
  return trpc.lookups.states.useQuery({ countryId }) as StateQueryResult;
}

/**
 * Query hook for fetching currencies
 */
export function useCurrencies() {
  return trpc.lookups.currencies.useQuery({}) as CurrencyQueryResult;
}
